module.exports = __webpack_public_path__ + "media/images/member_event-8e75248d41f02debeed9e484c7763bc6.svg";